<template>
    <li><a href="#" >{{tag}}</a></li>
</template>
<script>
export default {
    name:'comaSplit',
    props: ['tag']
}
</script>